import api from '../axios.js';

export const getListApprovedBankAccounts = async (params) => {
	return await api.get('/v2/bank_account', { params })
}

export const addBankAccount = async (data, config = {}) => {
	return await api.post('/v2/bank_account', data, config)
}

export const deleteApprovedBankAccount = async (id) => {
	return await api.patch(`/v2/bank_account/${id}`)
}

export const addIdentityValidation = async (data) => {
	return await api.post('/v2/bank_account/identity', data)
}

export const addImageVerification = async (data) => {
	return await api.post('/v2/bank_account/image_verification', data)
}

export const validateOtpEmail = async (data) => {
	return await api.post('/v2/bank_account/otp/validate_email', data)
}

export const validateOtpSms = async (data) => {
	return await api.post('/v2/bank_account/otp/validate_sms', data)
}

export const resendOtp = async (data) => {
	return await api.post('/v2/bank_account/otp/resend', data)
}

export const getBankList = async () => {
	return await api.get('/v2/bank_account/banks')
}

// Cash Withdrawal

export const getWithdrawals = async (params) => {
	return await api.get('/v2/bank_account/withdrawal', { params })
}

export const addRequestCashWithdrawals = async (data) => {
	return await api.post('/v2/bank_account/withdrawal', data)
}

export const validateOtpEmailWithdrawal = async (data) => {
	return await api.post('/v2/bank_account/withdrawal/otp/validate_email', data)
}

export const validateOtpSmsWithdrawal = async (data) => {
	return await api.post('/v2/bank_account/withdrawal/otp/validate_sms', data)
}